export const ToggleTestIdFactory = {
    getToggleBase: () => 'toggle',
    getToggleTestId: (testid) => [ToggleTestIdFactory.getToggleBase(), testid].join('-'),
    getToggleLabelTestId: (testid) => [ToggleTestIdFactory.getToggleBase(), 'label', testid].join('-'),
};
